import _ from 'underscore';
import { isBlank } from '../../helpers/common';

export class Base {
  // Override to return a different type
  static create() {
    return new this();
  }

  // If the given TargetingType is NOT an object (i.e., a simple boolean), then
  // it should subclass this method to handle the type correctly.
  static isValidType(target) {
    return !(target === null || target === undefined || !_.isObject(target));
  }

  // If the given TargetingType is NOT an object (i.e., a simple boolean, array), then
  // it should subclass this method to handle the type correctly.
  static isValid(target) {
    if (!this.isValidType(target)) {
      return false;
    }
    if (target instanceof this || target.isValid) {
      return target.isValid();
    }
    return Object.assign(new this(), target).isValid();
  }

  // count returns a count of targeting values selected or entered for the given
  // target type. If the target type does not support a count, returns null.
  // Otherwise, it is an integer >= 0.
  //
  // eslint-disable-next-line no-unused-vars
  static count(target) {
    if (this.isValid(target)) {
      return 1;
    }
    return null;
  }

  static isEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (isBlank(a) && isBlank(b)) {
      return true;
    }
    if (isBlank(a) || isBlank(b)) {
      // if only one is blank
      return false;
    }

    if (this.isValidType(a) !== this.isValidType(b)) {
      return false;
    }

    // cast both to objects
    const aa = a instanceof this ? a : Object.assign(new this(), a);
    const bb = b instanceof this ? b : Object.assign(new this(), b);

    // return comparison
    return aa.isEqualTo(bb);
  }

  // eslint-disable-next-line class-methods-use-this
  isValid() {
    // must be implemented by subclasses
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  isEqualTo(/* other */) {
    // must be implemented by subclasses of complex object value types.
    // this impl will almost always be false.
    return undefined;
  }
}
